<template>
  <transition-group name="list" tag="div" appear="">
    <template v-for="popup in popups" :key="popup.id">
      <component v-if="popup" :is="popup.component" :popupsData="popup" />
    </template>
  </transition-group>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { popups } from "@/utils/widget/popup.js";

const props = defineProps({
  popup: {
    type: Object,
    default: {},
    required: true,
  },
});
</script>
